import { message } from 'antd';
import {
  EUDR_DETECTION_FEATURE,
  eudrDetectionFeature,
} from '@xbcb/feature-flags';
import { uiStageToBackendStage } from '@xbcb/ui-types';
import { getEnv, safeGetMessage } from '@xbcb/ui-utils';
import {
  countIncompleteEudrEntries,
  eudrEntriesOfDeclaration,
  isEudrEntryVerifiable,
  submitEudrDdsVerification,
} from 'libs/eudr/submitEudrDdsVerification';
import { hasUnsavedGoodsChanges } from 'libs/formCore/transforms/hasUnsavedGoodsChanges';
import { AppRecordKebabMenuItem } from '../../../../types';

const show: AppRecordKebabMenuItem['show'] = ({ existingRecord }) =>
  EUDR_DETECTION_FEATURE.isEnabled(eudrDetectionFeature, {
    stage: uiStageToBackendStage[getEnv().stage],
  }) &&
  eudrEntriesOfDeclaration(existingRecord?.goodsShipment).some(
    isEudrEntryVerifiable,
  );

const action: AppRecordKebabMenuItem['action'] = async ({
  record,
  appRecordBundle,
}) => {
  if (hasUnsavedGoodsChanges()) {
    void message.warning(
      safeGetMessage(appRecordBundle, 'eudr_verify_save_changes'),
    );
    return;
  }
  const entries = eudrEntriesOfDeclaration(record?.goodsShipment);
  await submitEudrDdsVerification({
    customsDeclarationId: record.id,
    bundle: appRecordBundle,
    submittableCount: entries.filter(isEudrEntryVerifiable).length,
    incompleteCount: countIncompleteEudrEntries(entries),
    refetchQueries: ['CustomsDeclaration'],
  });
};

export const verifyEudrDds: AppRecordKebabMenuItem = {
  show,
  action,
  key: 'verifyEudrDds',
  text: ({ appRecordBundle }) =>
    safeGetMessage(appRecordBundle, 'verify_eudr_dds'),
};
